/* Shared primitives used across every School-System portal file. */
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export function F({ label, children, full }) {
  return (
    <div className={full ? "md:col-span-2" : ""}>
      <label className="text-[11px] uppercase tracking-widest text-white/50 font-bold">{label}</label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export function SelectField({ label, value, onChange, options, testId }) {
  return (
    <F label={label}>
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className="bg-white/5 border-white/10"><SelectValue placeholder="Select" /></SelectTrigger>
        <SelectContent className="bg-[#1a1a1a] border-white/10 text-white max-h-64">
          {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </F>
  );
}
